import { ZoomCallSummaryPanel } from "../../../components/ZoomCallSummaryPanel";

interface PostVisitSummaryCardProps {
  appointmentId: string;
  isVideoCall: boolean;
}

/**
 * Takes the pre-visit AI summary's place once the appointment is over. Only
 * Zoom calls produce a summary today; phone visits get one later.
 */
export const PostVisitSummaryCard = ({
  appointmentId,
  isVideoCall,
}: PostVisitSummaryCardProps) => (
  <section className="appointment-card">
    <div className="appointment-card__header">
      <h3 className="appointment-card__title">Post-appointment summary</h3>
    </div>
    {isVideoCall ? (
      <ZoomCallSummaryPanel appointmentId={appointmentId} />
    ) : (
      <div className="post-visit-placeholder" data-testid="phone-summary-placeholder">
        <span className="post-visit-placeholder__ribbon">
          Coming soon for phone appointments
        </span>
        <p className="post-visit-placeholder__text">
          A summary of the conversation will appear here after phone appointments, the
          same way it does for video calls.
        </p>
      </div>
    )}
  </section>
);
